import { makeApiCall, ApiResponse } from "./index";

const BASE_URL = process.env.REACT_APP_API_LOOKUP_URL;

//#region Country

// GET request
export function GetCountries(): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}countries`, "GET");
}

//#endregion Country

//#region State

// GET request
export function GetStatesByCountryId(countryId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}countries/${countryId}/states`, "GET");
}

//#endregion State

//#region State

// GET request
export function GetAllStatuses(
  objectType: string,
  params?: any
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}lookup/statuses/${objectType}`, "GET", params);
}

//#endregion State
